import React from 'react';
import {  Grid } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import { marginBottom } from "../../../config/styles";

export default function NoUserTriggerAlert () {

    return (
        <>        
        <Grid xs={12} style={marginBottom}>          
        <Alert icon={false} severity="info"> No user triggers.</Alert>       
        </Grid>
        </>

    )
}
